import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import type { SxProps, Theme } from '@mui/material/styles';

import { AddItemIcon } from '@/assets/icons/AddItemIcon';
import { mergeSx } from '@/utils/mergeSx';

import { addFormFieldStyles as sx } from './AddFormFieldButton.styles';

type Props = {
	onClick: () => void;
	label?: string;
	customSx?: SxProps<Theme>;
};

export const AddFormFieldButton = ({ onClick, label, customSx }: Props) => {
	if (label) {
		return (
			<Button
				disableRipple
				size='small'
				startIcon={<AddItemIcon sx={sx.icon} />}
				onClick={onClick}
				sx={mergeSx(sx.add, sx.labelled, customSx)}
			>
				{label}
			</Button>
		);
	}

	return (
		<IconButton
			disableRipple
			size='small'
			aria-label='Remove field'
			onClick={onClick}
			sx={mergeSx(sx.add, customSx)}
		>
			<AddItemIcon sx={sx.icon} />
		</IconButton>
	);
};
